var _rect, _g, _rect2, _rect3, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 61,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.5,
    width: 60,
    height: 60,
    rx: 30,
    fill: "#FEF2F2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#car-warning_svg__clip0_8401_15241)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6 27.168l-.015.01a2.56 2.56 0 00-1.14 2.131v10.154c0 .707.573 1.28 1.28 1.28h1.281a1.28 1.28 0 001.28-1.28v-1.28h17.928v1.28c0 .707.573 1.28 1.28 1.28h1.28a1.28 1.28 0 001.281-1.28V29.31a2.56 2.56 0 00-1.14-2.13l-.016-.01c.467-.27.89-.535.972-.653.198-.284.289-1.138 0-1.138h-2.377l-1.5-2.999a3.841 3.841 0 00-3.435-2.123H24.94a3.841 3.841 0 00-3.436 2.123l-1.499 2.999H17.63c-.289 0-.198.854 0 1.138.082.118.505.383.972.652zm4.098-4.276l-2.19 4.105a.64.64 0 00.565.942h18.354a.64.64 0 00.565-.942l-2.19-4.105a2.561 2.561 0 00-2.26-1.356H24.958c-.945 0-1.814.522-2.26 1.356zm-3.972 8.99v-1.548a.64.64 0 01.962-.553l4.276 2.494c.589.344.304 1.248-.376 1.191l-3.688-.307a1.28 1.28 0 01-1.174-1.276zm23.049-1.548v1.549c0 .666-.511 1.22-1.175 1.276l-3.688.307c-.68.057-.965-.847-.376-1.191l4.276-2.494a.64.64 0 01.963.553z",
    fill: "#DC2626"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 43.496,
    y: 1.246,
    width: 23.508,
    height: 23.508,
    rx: 11.754,
    fill: "#DC2626"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 43.496,
    y: 1.246,
    width: 23.508,
    height: 23.508,
    rx: 11.754,
    stroke: "#fff",
    strokeWidth: 1.493
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#car-warning_svg__clip1_8401_15241)",
    stroke: "#fff",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.25 18.666a5.666 5.666 0 100-11.332 5.666 5.666 0 000 11.332zM55.25 15.267h.005M55.25 10.734V13"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "car-warning_svg__clip0_8401_15241"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(14.884 15.134)",
    d: "M0 0h30.732v30.732H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "car-warning_svg__clip1_8401_15241"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(48.45 6.2)",
    d: "M0 0h13.599v13.599H0z"
  })))));
}
export default __webpack_public_path__ + "static/media/car-warning.6b627988.svg";
export { SvgCarWarning as ReactComponent };